import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import {DateRangePicker, DateRange} from 'react-date-range';

import nl from 'date-fns/locale/nl';
import React from "react";

const hiddenInput = document.querySelector('input[name="check_in_out"]')

const formatDate = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

const DateRangeInput = ({}) => {

    const [open, setOpen] = React.useState(false);

    const [value, setValue] = React.useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    React.useEffect(() => {

        // when opened, read value from hidden input
        if (open) {
            if (hiddenInput.value) {
                const value = JSON.parse(hiddenInput.value)
                setValue({
                    startDate: new Date(value[0]),
                    endDate: new Date(value[1]),
                    key: 'selection',
                })
            }
        }

    }, [open])

    const [price, setPrice] = React.useState(null)

    React.useEffect(() => {

        const priceUrl = hiddenInput.getAttribute('data-apartment-price-url')

        setPrice(null)
        const url = priceUrl + `?check_in=${formatDate(value.startDate)}&check_out=${formatDate(value.endDate)}`
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setPrice(data)
            });

    }, [value])


    const selectedDates = hiddenInput.value ? JSON.parse(hiddenInput.value) : null

    const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };

    let message = ''
    if (price && price.error) {
        message = price.error
    } else if (price && !price.error) {
        message = `Prijs per nacht: €${price.avg_night_price_with_discount}`
        if (price.discount_percentage) {
            message += ` (inclusief ${price.discount_percentage}% korting)`
        }
    }


    const [disabledDates, setDisabledDates] = React.useState([new Date()])
    React.useEffect(() => {
        const url = hiddenInput.getAttribute('data-apartment-availability-url') + `?year=${new Date().getFullYear()}&month=${new Date().getMonth() + 1}`
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setDisabledDates(data)
            });

    }, [])

    return (
        <div>
            <input
                type="text"
                className={"form-control"}
                placeholder={"Selecteer een van/tot datum"}
                value={selectedDates ?
                    `${new Date(selectedDates[0]).toLocaleDateString('nl', options)} - ` +
                    `${new Date(selectedDates[1]).toLocaleDateString('nl', options)}` : ''}
                onFocus={() => setOpen(true)}
                readOnly
                style={{cursor: 'pointer'}}
            />


            {open && <div className="card">
                <div className="card-body">
                    <DateRange
                        locale={nl}
                        ranges={[value]}
                        minDate={new Date()}
                        disabledDates={disabledDates}
                        months={2}
                        weekStartsOn={1}
                        direction="horizontal"
                        value={value}
                        onChange={(v) => {
                            console.log('onChange', v)
                            setValue(v.selection)
                        }}
                        onShownDateChange={(v) => {
                            console.log('onShownDateChange', v)
                        }}
                        shownDate={new Date()}

                    />
                </div>

                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <strong>{message}</strong>
                </div>

                <div className={"card-footer"} style={{textAlign: 'right'}}>

                    <button className={'btn btn-secondary'}
                            onClick={() => setOpen(false)}>Annuleer
                    </button>
                    &nbsp;

                    <button
                        disabled={!price || (price && price.error)}
                        className={"btn btn-primary"}
                        onClick={() => {
                            // setSelectedDates([value.startDate, value.endDate])
                            const v = JSON.stringify([
                                formatDate(value.startDate),
                                formatDate(value.endDate)
                            ])
                            hiddenInput.value = v
                            setOpen(false)
                        }}>Bevestig
                    </button>

                </div>
            </div>
            }
        </div>
    )
    //
    //
    // return (
    //     <div>
    //         date range input
    //     {/*<input*/}
    //     {/*    type="date"*/}
    //     {/*    value={value.startDate}*/}
    //     {/*    onChange={e => onChange({ ...value, startDate: e.target.value })}*/}
    //     {/*/>*/}
    //     {/*<input*/}
    //     {/*    type="date"*/}
    //     {/*    value={value.endDate}*/}
    //     {/*    onChange={e => onChange({ ...value, endDate: e.target.value })}*/}
    //     {/*/>*/}
    //     </div>
    // );
}
export default DateRangeInput